import { useState } from "react";
import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../../../../shared/components/button/CreateButtonTrigger";
import CreateClientMarketForm from "./CreateClientMarketForm";

const CreateClientMarketDialog = ({ onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="clients.detail.tabs.markets.createForm.title"
      description="clients.detail.tabs.markets.createForm.description"
      content={<CreateClientMarketForm onSubmitHandler={onSubmit} />}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateClientMarketDialog;
